import "./style.scss"
import React, { useEffect, useState } from "react"
import { sliderProperties } from "../../../utils"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const CustomerItem = ({ name, image, description, onClick, className }) => {
  return (
    <div
      className={`customer_item ${className ? className : ""}`}
      onClick={onClick ? onClick : null}
      onKeyDown={onClick ? onClick : null}
    >
      <img alt={name} src={image} />
      <div>
        <p className="name">{name}</p>
        <p className="description">{description}</p>
      </div>
    </div>
  )
}

const CustomerSection = ({ customers }) => {
  const [commentId, setCommentId] = useState(1)
  const [activeComment, setActiveComment] = useState()

  const selectCustomer = customer => {
    let items = document.getElementsByClassName("customer_item active")
    if (customer.id !== commentId) {
      for (let i = 0; i < items.length; i++) {
        items[i].className = "customer_item"
      }
      setCommentId(customer.id)
      setActiveComment({
        title: customer.commentTitle,
        comment: customer.comment,
      })
    }
  }
  useEffect(() => {
    setActiveComment({
      title: customers[0].commentTitle,
      comment: customers[0].comment,
    })
  }, [])
  return (
    <div className="customer_section">
      <h1 className="title">Our Customer</h1>
      <div className="desktop">
        <div className="customer_list">
          {customers &&
            customers.map((customer, index) => {
              return (
                <CustomerItem
                  key={index}
                  className={commentId === customer.id ? "active" : ""}
                  onClick={() => selectCustomer(customer)}
                  description={customer.description}
                  name={customer.name}
                  image={customer.image}
                />
              )
            })}
        </div>
        {activeComment && (
          <div className="customer_response_area">
            <h1 className="comment_header">{activeComment.title}</h1>
            <p className="comment">{activeComment.comment}</p>
          </div>
        )}
      </div>
      <div className="mobile">
        <Carousel
          dotListClass="custom-dot-list-style"
          showDots={true}
          arrows={false}
          responsive={sliderProperties}
        >
          {customers &&
            customers.map((customer, index) => {
              return (
                <div key={index}>
                  <div className="customer_response_area">
                    <h1 className="comment_header">{customer.commentTitle}</h1>
                    <p className="comment">{customer.comment}</p>
                  </div>
                  <CustomerItem
                    className="active"
                    description={customer.description}
                    name={customer.name}
                    image={customer.image}
                  />
                </div>
              )
            })}
        </Carousel>
      </div>
    </div>
  )
}

export default CustomerSection
